module.exports = __webpack_public_path__ + "media/3.f2b9a70c.mp3";